import { QUEUE_TYPE } from "@elixir/types";
import { useMutation } from "@tanstack/react-query";
import { navigateLocal } from "../../organisms/queue/queue-header";
import useQueueStore from "../../stores/queue-store";
import getBridges from "../../utils/bridges/get-bridges";
import rescheduleAppointment from "../../controllers/appointments/reschedule";

const usePostRescheduleAppointment = () => {
  const setSelectedDate = useQueueStore((state) => state.setSelectedDate);
  const setClinicId = useQueueStore((state) => state.setClinicId);

  return useMutation(rescheduleAppointment, {
    onSuccess: ({ data }) => {
      if (data) {
        setSelectedDate(new Date(data.full_date.toDate()));
        getBridges()?.changeClinic(data.clinic_id);
        navigateLocal(data.clinic_id, QUEUE_TYPE.BOOKED);
        setClinicId(data.clinic_id);
      }
    },
  });
};

export default usePostRescheduleAppointment;
